import { RefObject, useEffect } from "react";

/**
 * Hook to detect clicks outside of a specified element
 * @param ref - React ref object pointing to the element
 * @param handler - Callback function to execute when clicking outside
 */
export function useClickOutside<T extends HTMLElement = HTMLElement>(
  ref: RefObject<T | null>,
  handler: (event: MouseEvent | TouchEvent) => void,
): void {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      const el = ref.current;

      // Do nothing if clicking ref's element or descendent elements
      if (!el || el.contains(event.target as Node)) {
        return;
      }

      handler(event);
    };

    document.body.addEventListener("click", listener);
    document.body.addEventListener("touchstart", listener);

    return () => {
      document.body.removeEventListener("click", listener);
      document.body.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
}
